import { RootState } from 'src/store/rootStore';
export const selectWebViewFileUrl = (state: RootState) => state.design.design?.downloadUrl;
export const selectDesignStatus = (state: RootState) => state.design.design?.status;
export const selectDesignRequestStatus = (state: RootState) => state.design.requestStatus;
